import React, { useState, useEffect, useRef, useCallback } from 'react';

export const UPGRADES = {
  aerodynamics: { name: 'Sleek Folds', icon: '💨', desc: 'Reduce drag', maxLevel: 10 },
  boost: { name: 'Rocket Tape', icon: '⚡', desc: 'More boost power', maxLevel: 10 },
  lift: { name: 'Wing Span', icon: '🪶', desc: 'Better gliding', maxLevel: 10 },
  coins: { name: 'Coin Magnet', icon: '🧲', desc: 'Larger pickup radius', maxLevel: 5 },
};

export const MILESTONES = [50, 100, 200, 350, 500, 750, 1000, 1500, 2000, 3000, 5000];

export const ZONES = [
  { start: 0, name: 'City Park', skyTop: '#87CEEB', skyBottom: '#E0F7FA', ground: '#4ade80' },
  { start: 500, name: 'Countryside', skyTop: '#38bdf8', skyBottom: '#bae6fd', ground: '#22c55e' },
  { start: 1500, name: 'Mountains', skyTop: '#0ea5e9', skyBottom: '#7dd3fc', ground: '#64748b' },
  { start: 3000, name: 'Clouds', skyTop: '#0369a1', skyBottom: '#38bdf8', ground: '#94a3b8' },
  { start: 5000, name: 'Stratosphere', skyTop: '#0f172a', skyBottom: '#1e3a5a', ground: '#475569' },
];